import type { Icon } from '@phosphor-icons/react/dist/lib/types'
import { ChartLine as ChartLineIcon } from '@phosphor-icons/react/dist/ssr/ChartLine'
import { ChartLineUp as ChartLineUpIcon } from '@phosphor-icons/react/dist/ssr/ChartLineUp'
import { ChartPie as ChartPieIcon } from '@phosphor-icons/react/dist/ssr/ChartPie'
import { Chat as ChatIcon } from '@phosphor-icons/react/dist/ssr/Chat'
import { CheckCircle as CheckCircleIcon } from '@phosphor-icons/react/dist/ssr/CheckCircle'
import { CreditCard as CreditCardIcon } from '@phosphor-icons/react/dist/ssr/CreditCard'
import { Footprints as FootprintsIcon } from '@phosphor-icons/react/dist/ssr/Footprints'
import { Gear as GearIcon } from '@phosphor-icons/react/dist/ssr/Gear'
import { Globe as GlobeIcon } from '@phosphor-icons/react/dist/ssr/Globe'
import { GridNine as GridIcon } from '@phosphor-icons/react/dist/ssr/GridNine'
import { House as HouseIcon } from '@phosphor-icons/react/dist/ssr/House'
import { Info as InfoIcon } from '@phosphor-icons/react/dist/ssr/Info'
import { MagicWand as MagicWandIcon } from '@phosphor-icons/react/dist/ssr/MagicWand'
import { Package as PackageIcon } from '@phosphor-icons/react/dist/ssr/Package'
import { Pulse as PulseIcon } from '@phosphor-icons/react/dist/ssr/Pulse'
import { Question as QuestionIcon } from '@phosphor-icons/react/dist/ssr/Question'
import { Receipt as ReceiptIcon } from '@phosphor-icons/react/dist/ssr/Receipt'
import { ShoppingBagOpen as ShoppingBagOpenIcon } from '@phosphor-icons/react/dist/ssr/ShoppingBagOpen'
import { SquaresFour as SquaresFourIcon } from '@phosphor-icons/react/dist/ssr/SquaresFour'
import { Storefront as StoreIcon } from '@phosphor-icons/react/dist/ssr/Storefront'
import { Tag as TagIcon } from '@phosphor-icons/react/dist/ssr/Tag'
import { Truck as TruckIcon } from '@phosphor-icons/react/dist/ssr/Truck'
import { Video as VideoIcon } from '@phosphor-icons/react/dist/ssr/Video'

export const icons = {
	'chart-pie': ChartPieIcon,
	'check-circle': CheckCircleIcon,
	'credit-card': CreditCardIcon,
	'shopping-bag-open': ShoppingBagOpenIcon,
	'chart-line': ChartLineIcon,
	'chart-line-up': ChartLineUpIcon,
	footprints: FootprintsIcon,
	'magic-wand': MagicWandIcon,
	question: QuestionIcon,
	info: InfoIcon,
	house: HouseIcon,
	store: StoreIcon,
	receipt: ReceiptIcon,
	truck: TruckIcon,
	gear: GearIcon,
	globe: GlobeIcon,
	grid: GridIcon,
	package: PackageIcon,
	heartbeat: PulseIcon,
	tag: TagIcon,
	video: VideoIcon,
	chat: ChatIcon,
	'squares-four': SquaresFourIcon,
} as Record<string, Icon>
